



































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RegisterTimeModal from "@/components/modals/RegisterTimeModal.vue";
import AnimatedNumber from "@/components/AnimatedNumber.vue";
import Button from "@/components/Button.vue";
import http from "@/methods/http.ts";
import moment from "moment";

@Component({
  components: {
    RegisterTimeModal,
    AnimatedNumber,
    Button,
  },
  filters: {
    cut(value) {
      return value.length > 20 ? `${value.substring(0, 20)}...` : value;
    },
  },
})
export default class Schedule extends Vue {
  @Prop() slug;
  @Prop() specialist;
  @Prop(String) startDate;
  @Prop() services;
  @Prop() admin;

  moment = moment;

  timestamp = moment().subtract(1, "days").endOf("day").unix();

  newday = "";
  newperiod = "";
  newperiods = [];

  @Watch("startDate", { deep: true, immediate: true })
  @Watch("specialist", { deep: true, immediate: true })
  onStartDateChange() {
    this.getSchedule();
    this.getSpecOrders();
  }

  colors = ["#2F80ED", "#F2C94C", "#ddd", "#eee"];

  zcolors = [];
  schedule = [];
  orders = [];
  chosenCompany: any = { times: "00:00 - 23:59", periods: [] };
  chosenService: any = { duration: "00:30:00" };
  chosenDay: string = "";
  specModal = false;

  datestamp(date) {
    return moment(date, "DD.MM.YYYY").unix();
  }

  getRowFromTime(start, end) {
    return (
      ((moment.duration(end).asMinutes() - moment.duration(start).asMinutes()) /
        60) *
      63
    );
  }

  get periods() {
    if (
      !this.chosenCompany ||
      !this.chosenService.name ||
      !this.chosenDay.length
    )
      return [];

    const start: string = this.chosenCompany.times.split(" - ")[0];
    const globEnd: string = this.chosenCompany.times.split(" - ")[1];
    const sect: string = this.chosenService.duration;
    const orders: any[] = this.sortedByDayOrders[this.chosenDay];
    const lunch: any = this.chosenCompany.periods.find(
      (i) => i.p_type === "lunch"
    );
    const live: any = this.chosenCompany.periods.find(
      (i) => i.p_type === "live"
    );
    const rest_time: any = this.chosenCompany.periods.find(
      (i) => i.p_type === "rest_time"
    );

    let redtime = [];
    this.chosenCompany.periods.map((i) => {
      if (i.p_type === "rest_time") {
        redtime.push(i);
      }
    });

    const chosenDay: string = this.chosenDay;

    //const lunch_and_rest_time = {...lunch, ...rest_time};
    const r = this.reorderSchedule(
      chosenDay,
      start,
      globEnd,
      sect,
      orders,
      lunch,
      redtime,
      live
    );
    return r;

    //return this.workOnPeriods(start, globEnd, sect, orders, lunch_and_rest_time);
  }

  reorderSchedule(
    chosenDay,
    start,
    globEnd,
    sect,
    orders,
    lunch,
    rest_time,
    live
  ) {
    let arr = [];
    let periods = [];

    if (lunch || (rest_time && rest_time.length > 0) || live) {
      if (live) {
        arr.push(live.start_time + "-" + live.end_time);
      }
      if (lunch) {
        arr.push(lunch.start_time + "-" + lunch.end_time);
      }
      if (rest_time.length > 0) {
        for (var k in rest_time) {
          arr.push(rest_time[k].start_time + "-" + rest_time[k].end_time);
        }
      }
      arr.push(start + "-" + null);
      arr.push(null + "-" + globEnd);
    } else {
      arr.push(start + "-" + globEnd);
    }

    arr.sort();
    //console.log(arr);

    let arr2 = [];
    if (arr.length > 1) {
      for (var k in arr) {
        var next = k * 1 + 1;
        if (next >= arr.length) {
          next = k;
        }
        var back = k * 1 - 1;
        if (back <= arr.length) {
          back = k;
        }
        if (arr[k].split("-")[0] == "null") {
          // do nothing
        } else if (arr[k].split("-")[1] == "null") {
          arr2.push(arr[k].split("-")[0] + "-" + arr[next].split("-")[0]);
        } else {
          if (arr[next].split("-")[0] == "null") {
            arr2.push(arr[k].split("-")[1] + "-" + arr[next].split("-")[1]);
          } else {
            arr2.push(arr[k].split("-")[1] + "-" + arr[next].split("-")[0]);
          }
        }
      }
    } else {
      arr2 = arr;
    }

    for (var k in arr2) {
      let orderArr: any[];
      if (orders && orders.length > 0) {
        let tempOrderArr = [];
        for (var z in orders) {
          var st = arr2[k].split("-")[0].replace(":", "") * 1;
          var et = arr2[k].split("-")[1].replace(":", "") * 1;
          var idx =
            orders[z].date_time_reservation.split(" ")[1].replace(":", "") * 1;
          if (idx >= st && idx <= et) {
            tempOrderArr.push(orders[z]);
          }
        }
        if (tempOrderArr.length > 0) {
          orderArr = tempOrderArr;
        }
      }
      //console.log(orderArr);
      periods = periods.concat(
        this.workOnPeriods(
          arr2[k].split("-")[0],
          arr2[k].split("-")[1],
          sect,
          orderArr,
          {},
          chosenDay
        )
      );
    }
    return periods;
  }

  checkIfHasFreePeriods(times, orders, company) {
    const sect = this.services.length ? this.services[0].duration : "00:15:00";
    const start: string = times.split(" - ")[0];
    const globEnd: string = times.split(" - ")[1];
    const lunch = company.periods.find((i) => i.p_type === "lunch");
    const rest_time = company.periods.find((i) => i.p_type === "rest_time");

    const lunch_and_rest_time = { ...lunch, ...rest_time };

    return (
      this.workOnPeriods(start, globEnd, sect, orders, lunch_and_rest_time)
        .length > 0
    );
  }

  checkIfInThisDuration(time, dur, start, end) {
    return (
      moment(start, "HH:mm:ss").diff(moment(time.split(" ")[1], "HH:mm")) <=
        0 &&
      moment(end, "HH:mm:ss").diff(moment(time.split(" ")[1], "HH:mm")) >= 0
    );
  }

  reservationCreatedHandler() {
    this.getSpecOrders();
    this.specModal = false;
  }

  workOnPeriods(start, globEnd, sect, orders, lunch, chosenDay = "") {
    let currentOrder = orders
      ? orders[0]
      : { date_time_reservation: "01.01.1970 23:59" };
    let current = start;
    let periods = [];

    let todayDay = moment().format("DD.MM.YYYY");
    let nowTime = moment().unix();
    let startTime = moment(start, "HH:mm").unix();
    if (todayDay == chosenDay && startTime < nowTime) {
      let finish = moment();
      let remainder = 15 - (finish.minute() % 15);
      current = moment(finish).add(remainder, "minutes").format("HH:mm");
    }

    function generatePeriods() {
      startTime = moment(current, "HH:mm").unix();
      if (todayDay == chosenDay && startTime < nowTime) {
        let finish = moment();
        let remainder = 15 - (finish.minute() % 15);
        current = moment(finish).add(remainder, "minutes").format("HH:mm");
      }

      let now = moment(current, "HH:mm");
      let dur = moment.duration(sect);
      let end = now.add(dur);

      if (end.diff(moment(globEnd, "HH:mm")) > 0) {
        return;
      }
      //if (lunch && (end.diff(moment(lunch.start_time, 'HH:mm:ss')) >= 0 && end.diff(moment(lunch.end_time, 'HH:mm:ss')) <= 0)) {
      if (
        lunch &&
        end.diff(moment(lunch.start_time, "HH:mm:ss")) > 0 &&
        end.diff(moment(lunch.end_time, "HH:mm:ss")) <= 0
      ) {
        current = moment(lunch.end_time, "HH:mm:ss").format("HH:mm");
      } else if (
        end.diff(
          moment(currentOrder.date_time_reservation.split(" ")[1], "HH:mm")
        ) <= 0
      ) {
        periods.push({ start: current, end: end.format("HH:mm") });
        current = end.format("HH:mm");
      } else {
        current = moment(
          currentOrder.date_time_reservation.split(" ")[1],
          "HH:mm"
        )
          .add(moment.duration(currentOrder.duration))
          .format("HH:mm");
        currentOrder = orders[orders.indexOf(currentOrder) + 1]
          ? orders[orders.indexOf(currentOrder) + 1]
          : { date_time_reservation: "01.01.1970 23:59" };
      }
      generatePeriods();
    }
    generatePeriods();
    return periods;
  }

  get sortedByDayOrders() {
    let orderedByDays = {};
    this.orders.map((i) => {
      let date = moment(i.date_time_reservation, "DD.MM.YYYY hh:mm").format(
        "DD.MM.YYYY"
      );
      orderedByDays[date]
        ? orderedByDays[date].push(i)
        : (orderedByDays[date] = [i]);
    });
    return orderedByDays;
  }

  createOrder(c, day) {
    if (this.$store.state.token) {
      if (this.datestamp(day.day) >= this.timestamp) {
        this.openModal(c, day);
      }
    } else {
      this.$store.commit("notificate", {
        text: "Для записи вам нужно зарегистрироваться",
        type: "error",
      });
    }
  }

  getSchedule() {
    let orgs = this.specialist.company;
    let orgs_list = [];
    orgs_list.push("-1");
    for (let key in orgs) {
      if (orgs[key].checked === true) {
        orgs_list.push(orgs[key].id);
      }
    }
    http(`masters/${this.slug}/schedule/beta`, "get", false, {
      day: this.startDate,
      day_count: 7,
      orgs: orgs_list,
    }).then((r) => {
      let isEmpty = false;
      this.schedule = r.data;
    });
  }

  getSpecOrders() {
    http(`masters/${this.slug}/reservations`, "get", false, {
      date_time_start: this.startDate,
      date_time_end: moment(this.startDate, "DD.MM.YYYY")
        .add(7, "d")
        .format("DD.MM.YYYY"),
    }).then((r) => {
      this.orders = r.data;
    });
  }

  openModal(c, day) {
    if (
      this.checkIfHasFreePeriods(
        c.times,
        this.sortedByDayOrders[this.formatDate(day.day)],
        c
      )
    ) {
      this.specModal = true;
      this.chosenCompany = c;
      this.chosenDay = day.day;
    }
  }

  formatTime(time) {
    return moment(time, "HH:mm:ss").format("HH:mm");
  }

  formatDate(day) {
    return moment(day, "DD.MM.YYYY").format("DD.MM.YYYY");
  }

  convertDayDate(d) {
    moment.locale("ru");
    let date = moment(d, "DD.MM.YYYY");
    return [date.format("DD"), date.format("MMMM"), date.format("dd")];
  }

  divideToCompanies(periods) {
    let orgs = this.specialist.company;
    let companies = {};
    periods.map((i) =>
      companies[i.owner]
        ? companies[i.owner].push(i)
        : (companies[i.owner] = [i])
    );

    let companiesArr = [];
    for (let key in companies) {
      let street_address = "";
      let workPers = [];
      orgs.map((i) => {
        if (i.name === key) street_address = i.street_address;
      });
      companies[key].map((i) => {
        if (i.p_type === "work") workPers.push(i);
      });
      companiesArr.push({
        owner: key,
        street_address: street_address,
        periods: companies[key],
        times: `${this.formatTime(workPers[0].start_time)} - ${this.formatTime(
          workPers[workPers.length - 1].end_time
        )}`,
      });
    }
    companiesArr.map((i, index) => {
      i.color = this.colors[index];
    });
    return companiesArr;
  }

  getDuration(duration) {
    const l = duration.length;
    const r =
      parseInt(duration) === 0
        ? parseInt(duration.substring(l - 2))
        : parseInt(duration);
    return r;
  }

  mounted() {
    this.getSchedule();
    this.getSpecOrders();

    window["moment"] = this.moment;

    let owner_colors = [];
    let color_palette = this.colors;
    let i = 0;
    if (this.specialist.company) {
      this.specialist.company.forEach(function (element) {
        owner_colors[element.owner] = color_palette[i];
        i++;
      });
      this.zcolors = owner_colors;
    }
  }
}
